<template>
  <div class="start-title">
    <img class="title" src="@/assets/top/LASHIC_healthlab_logo.png" width="1880" height="203" loading="lazy"/>
  </div>
</template>

<script>
export default {
  name: "Start",
  beforeDestroy() {
    document.body.className = "";
  },
  mounted() {
    document.body.className = "color";
    setTimeout(this.TransitionToTop, 5000);
  },
  methods: {
    TransitionToTop() {
      this.$router.push("/top")
    }
  }
};
</script>

<style scoped>
.start-title {
    margin-top: 80%;
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/pages/Start.vue